function preloadTimeout() {
  setTimeout(() => {
    document.querySelector('.body').classList.add('loaded')
  }, 100)
  setTimeout(() => {
    document.querySelector('.body').classList.add('preload--hidden')
    document.querySelector('.body').classList.remove('preload--transitions')
  }, 400)
}

const moduleMap: Record<string, () => Promise<any>> = {
  '.form': () => import('components/form'),
  '.header': () => import('sections/header'),
  '.mobile-navigation': () => import('components/navigation/mobile-navigation'),
  '.main-navigation': () => import('components/navigation/main-navigation'),
  '.subnav': () => import('components/navigation/subnavigation'),
  '.accordion': () => import('components/accordion'),
  '.read-more': () => import('components/read-more'),
  '.sailing-schedule': () => import('components/sailing-schedule/sailing-schedule'),
  '.sailing-schedule__p2p-list': () => import('components/sailing-schedule/sailing-schedule-p2p'),
  '.ar-vessel-block__list': () => import('components/vessel'),
  '.sailing-schedule-block': () => import('components/sailing-schedule/sailing-schedule-block'),
  '.dpicker': () => import('components/datepicker'),
  '.moving-calculator': () => import('sections/moving-calculator'),
  '.amount-control': () => import('components/amount-control'),
  '.fake-select': () => import('components/fake-select'),
  '.articles': () => import('components/article-category/article-sorting'),
  '.youtube-block': () => import('blocks/youtube-block'),
  '.search': () => import('sections/search'),
  '.sidebar-select': () => import('components/sidebar/sidebar-select'),
  '.history-block': () => import('components/sidebar/history-nav'),
  '.notifications': () => import('components/notifications'),
  '.office-overview, .office': () => import('components/office/office-overview'),
  '.office': () => import('components/office/office-overview'),
  '.rate-request': () => import('sections/rate-request/rate-request'),
  '.stream': () => import('components/stream'),
  '.image-gallery-block__swiper': () => import('blocks/image-gallery-block'),
  '.js-p-target': () => import('components/priority-nav'),
  '.financial-block': () => import('blocks/financial-statement-block'),
  '.contact-hint-form': () => import('components/contact-hint-form'),
  '.ar-nav': () => import('components/ar-nav'),
  '.whistleblower-report': () => import('components/whistleblower-report'),
  '.calendar-month': () => import('components/modal/modal-calendar'),
  '.domestic-calculator': () => import('sections/domestic-calculator'),
  '.volume-calculator': () => import('components/volume-calculator'),
}

function scripts() {
  // import('focus-visible').then((module) => module())
  //
  // Comments test

  import('utility/prefetch').then((module) => module.default.init())
  import('components/modal/modal').then((module) => module.default.init())

  import('libs/clickoutside').then(async (module) => {
    const mobileNavigation = (await import('components/navigation/mobile-navigation')).default
    const accordionComponent = (await import('components/accordion')).default
    const accordion = document.querySelectorAll<HTMLElement>('.accordion')

    return module.default(() => {
      if (accordion) {
        accordionComponent.reset(new Event('reset'))
      }
      if (mobileNavigation.el.root.classList.contains('open')) {
        mobileNavigation.reset()
      }
    })
  })

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const target = entry.target as HTMLElement
        // Iterate through keys of moduleMap to find matching selectors
        const matchedSelector = Object.keys(moduleMap).find((key) => {
          if (key.includes(',')) {
            // If key contains commas, split and check each part
            return key.split(',').some((subSelector) => target.matches(subSelector.trim()))
          }
          // Regular match for single selectors
          return target.matches(key)
        })

        if (!matchedSelector) {
          return
        }

        moduleMap[matchedSelector]()
          .then((module) => {
            if (module.default && typeof module.default.init === 'function') {
              module.default.init(target)
            }
            observer.unobserve(target)
          })
          .catch((error) => console.error(`Error loading module for selector ${matchedSelector}:`, error))
      }
    })
  })

  Object.keys(moduleMap).forEach((selector) => {
    if (selector.includes(',')) {
      // Handle multiple selectors split by commas
      selector.split(',').forEach((subSelector) => {
        document.querySelectorAll(subSelector.trim()).forEach((element) => {
          observer.observe(element)
        })
      })
      return
    }

    document.querySelectorAll(selector).forEach((element) => {
      observer.observe(element)
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  preloadTimeout()

  if (document.querySelectorAll<HTMLElement>('[data-scroll]')) {
    import('components/scrollers').then((module) => module.default.init())
  }

  scripts()
})

// window.onload = scripts

document.body.addEventListener('htmx:afterSettle', () => {})

// HTMX cleanup event.
// document.body.addEventListener('htmx:beforeSwap', (e: CustomEvent) => {
//   // Remove 'button--loading' class from all buttons
//   document.querySelectorAll('.button--loading').forEach((button) => button.classList.remove('button--loading'))

//   const target = e.detail.target

//   // Skip scrolling if the target has specific classes
//   if (
//     (target?.classList &&
//       ['product-calendar__pickup', 'product-calendar'].some((cls) => target.classList.contains(cls))) ||
//     e.detail.pathInfo.requestPaths.contains('n')
//   ) {
//     return
//   }

//   window.scrollTo({ top: 0, behavior: 'smooth' })
// })
